(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
  function reyraUpdateRelated(root) {
    const track = root.querySelector('.reyra-related__track');
    if (!track) return;
    const previous = root.querySelector('[data-reyra-related-prev]');
    const next = root.querySelector('[data-reyra-related-next]');
    previous.disabled = track.scrollLeft <= 2;
    next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
  }
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-reyra-related-prev], [data-reyra-related-next]');
    if (!button) return;
    const root = button.closest('.reyra-related');
    const track = root.querySelector('.reyra-related__track');
    const direction = button.hasAttribute('data-reyra-related-next') ? 1 : -1;
    track.scrollBy({ left: direction * track.clientWidth, behavior: 'smooth' });
  });
  document.addEventListener('scroll', event => {
    if (event.target.matches && event.target.matches('.reyra-related__track')) {
      reyraUpdateRelated(event.target.closest('.reyra-related'));
    }
  }, true);
  function reyraObserveRelated(root) {
    if (root.dataset.reyraRelatedReady) return;
    root.dataset.reyraRelatedReady = 'true';
    new MutationObserver(() => reyraUpdateRelated(root)).observe(root, { childList: true });
    reyraUpdateRelated(root);
  }
  document.querySelectorAll('.reyra-related').forEach(reyraObserveRelated);
  document.addEventListener('shopify:section:load', event => {
    event.target.querySelectorAll('.reyra-related').forEach(reyraObserveRelated);
  });
  window.addEventListener('resize', () => document.querySelectorAll('.reyra-related').forEach(reyraUpdateRelated));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reyra-about"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('shopify:block:select', event => {
  const story = event.target.closest('.reyra-about__dropdown');
  if (story) story.open = true;
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reyra-care-guide"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('shopify:block:select',event=>{const card=event.target.closest('.reyra-care__card');if(card)card.open=true;});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reyra-faq-navigation"] && !Shopify.designMode) return;
  try {
    
const syncReyraFaqTopics = () => {
  document.querySelectorAll('.reyra-faq-nav a[href^="#faq-"]').forEach(link => {
    link.closest('li').hidden = !document.getElementById(link.hash.slice(1));
  });
};
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', syncReyraFaqTopics, { once: true });
} else {
  syncReyraFaqTopics();
}
document.addEventListener('shopify:section:load', syncReyraFaqTopics);
document.addEventListener('shopify:section:unload', syncReyraFaqTopics);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reyra-faq-topic"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('shopify:block:select', event => {
  const question = event.target.closest('.reyra-faq-question');
  if (question) question.open = true;
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reyra-material-details"] && !Shopify.designMode) return;
  try {
    document.addEventListener('shopify:block:select',e=>{const d=e.target.closest('.reyra-material-details details');if(d)d.open=true;});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reyra-shop-by-meaning"] && !Shopify.designMode) return;
  try {
    
function initMeaningFilters() {
  document.querySelectorAll('.reyra-meanings').forEach(root => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const stone = root.querySelector('[data-stone]');
    const meaning = root.querySelector('[data-meaning]');
    const params = new URLSearchParams(location.search);
    stone.value = params.get('stone') || '';
    meaning.value = params.get('meaning') || '';
    const apply = () => {
      let shown = 0;
      root.querySelectorAll('[data-stone-group]').forEach(group => {
        const matches = (!stone.value || group.dataset.stoneGroup === stone.value) &&
          (!meaning.value || group.dataset.meanings.split(',').includes(meaning.value));
        group.hidden = !matches;
        if (matches) shown++;
      });
      root.querySelector('[data-no-matches]').hidden = shown > 0;
    };
    stone.addEventListener('change', apply);
    meaning.addEventListener('change', apply);
    apply();
  });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initMeaningFilters);
else initMeaningFilters();
document.addEventListener('shopify:section:load', initMeaningFilters);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reyra-shop-the-look"] && !Shopify.designMode) return;
  try {
    
  function reyraInitLooks(root) {
    if (root.dataset.reyraReady) return;
    root.dataset.reyraReady = 'true';
    const slides = [...root.querySelectorAll('[data-reyra-look]')];
    const previous = root.querySelector('[data-reyra-look-nav="previous"]');
    const next = root.querySelector('[data-reyra-look-nav="next"]');
    const counter = root.querySelector('.reyra-looks__counter');
    if (!slides.length) return;
    let index = 0;
    function show(nextIndex) {
      index = Math.max(0, Math.min(slides.length - 1, nextIndex));
      slides.forEach((slide, slideIndex) => { slide.hidden = slideIndex !== index; });
      previous.disabled = index === 0;
      next.disabled = index === slides.length - 1;
      counter.textContent = slides.length > 1 ? (index + 1) + ' / ' + slides.length : '';
    }
    previous.addEventListener('click', () => show(index - 1));
    next.addEventListener('click', () => show(index + 1));
    show(0);
  }
  document.querySelectorAll('[data-reyra-looks]').forEach(reyraInitLooks);
  document.addEventListener('shopify:section:load', event => {
    event.target.querySelectorAll('[data-reyra-looks]').forEach(reyraInitLooks);
  });

  } catch(e) { console.error(e); }
})();
})();
